"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _toArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _addDays = _interopRequireDefault(require("date-fns/addDays"));
var _localization = require("@lt/localization");
var _userflow = require("../../icons-react/userflow");
var _hotel = require("../../proptypes/hotel");
var _userflow2 = require("../../utils/userflow");
var _HotelOfferButton = _interopRequireDefault(require("../HotelOfferButton/HotelOfferButton"));
var _CashBack = require("../CashBack");
var _HotelOfferInfo = _interopRequireWildcard(require("../HotelOfferInfo/HotelOfferInfo"));
var _HotelOffersDropdown = _interopRequireDefault(require("../HotelOffersDropdown"));
var _HintButton = _interopRequireDefault(require("../HintButton"));
var _Button = _interopRequireDefault(require("../Button"));
var _symbols = require("../../constants/symbols");
var _date = require("../../utils/date");
var _excluded = ["showNights", "nightsCount", "mealType", "offers", "isActive", "onOfferClicked", "onItemHovered", "isMobile", "isLast", "onHeaderClicked", "isHotelOnly", "isWhiteLabel", "startDate"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var VARIANTS_PLURALIZE = [_localization.i18n.t('hotel.offer.variants', {
  count: 0
}), _localization.i18n.t('hotel.offer.variants', {
  count: 1
}), _localization.i18n.t('hotel.offer.variants', {
  count: 2
})];
function makeDropdownLabel(offers, bestOfferOperator) {
  var operators = offers.reduce(function (set, offer) {
    return set.add(offer.operator_id);
  }, new Set());
  var offersCount = offers.length;
  return /*#__PURE__*/_react["default"].createElement(StyledDropdownLabel, null, "".concat(_localization.i18n.t('hotel.offer.still'), " ").concat(offersCount, " ").concat((0, _userflow2.pluralize)(offersCount, VARIANTS_PLURALIZE)));
}
var HotelOfferCell = /*#__PURE__*/_react["default"].memo(function (props) {
  var showNights = props.showNights,
    nightsCount = props.nightsCount,
    mealType = props.mealType,
    offers = props.offers,
    isActive = props.isActive,
    onOfferClicked = props.onOfferClicked,
    onItemHovered = props.onItemHovered,
    isMobile = props.isMobile,
    isLast = props.isLast,
    onHeaderClicked = props.onHeaderClicked,
    isHotelOnly = props.isHotelOnly,
    isWhiteLabel = props.isWhiteLabel,
    startDate = props.startDate,
    rest = (0, _objectWithoutProperties2["default"])(props, _excluded);
  var _ref = offers || [],
    _ref2 = (0, _toArray2["default"])(_ref),
    bestOffer = _ref2[0],
    otherOffers = _ref2.slice(1);
  var showTooltip = isActive && isLast;
  var endDate = (0, _addDays["default"])((0, _date.getCurrentUTCDate)(startDate), nightsCount);
  var shortEndDate = (0, _date.formatDate)(endDate, 'd MMM, EEEEEE');
  var hasSuperCashback = !isWhiteLabel && (0, _CashBack.hasCashbackSuperType)(bestOffer === null || bestOffer === void 0 ? void 0 : bestOffer.cashback_identifier);
  return /*#__PURE__*/_react["default"].createElement(StyledContainer, (0, _extends2["default"])({}, rest, {
    isActive: isActive,
    isLast: isLast,
    onMouseEnter: onItemHovered && function () {
      return onItemHovered(nightsCount);
    },
    onFocus: Function.prototype
  }), showNights && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(StyledNight, {
    onClick: onHeaderClicked
  }, "".concat(nightsCount, " ").concat(_symbols.MOON)), /*#__PURE__*/_react["default"].createElement(StyledEndDate, {
    isActive: isActive
  }, "".concat(_localization.i18n.t('filters.prices.before'), " ").concat(shortEndDate))), /*#__PURE__*/_react["default"].createElement(StyledMealType, null, /*#__PURE__*/_react["default"].createElement(StyledMealIcon, null), mealType), bestOffer ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(StyledBestOffer, {
    price: bestOffer.price,
    instantConfirm: bestOffer.extras.instant_confirm
    // TODO: free cancel?
    ,
    hotPrice: bestOffer.extras.cheap,
    hasSuperCashback: hasSuperCashback,
    isActive: isActive,
    onClick: function onClick() {
      return onOfferClicked(bestOffer);
    },
    isHotelOnly: isHotelOnly,
    "data-at-hotel-hotel-card": bestOffer.link
  }), /*#__PURE__*/_react["default"].createElement(_HotelOfferInfo["default"], {
    pricePerNight: (bestOffer.price / bestOffer.nights_count).toFixed(),
    operator: bestOffer.operator_name,
    extras: bestOffer.extras,
    ltExtras: bestOffer.lt_extras,
    labels: bestOffer.labels,
    included: (0, _userflow2.makeIncludedServices)(bestOffer),
    availability: bestOffer.availability,
    isMobile: isMobile,
    isHotelOnly: isHotelOnly
  })) : /*#__PURE__*/_react["default"].createElement(StyledNoOffers, {
    isVisible: isActive
  }, _localization.i18n.t('hotel.offer.noOffers')), !(0, _isEmpty2["default"])(otherOffers) && !isHotelOnly && /*#__PURE__*/_react["default"].createElement(StyledOffersDropdown, {
    offers: otherOffers,
    label: makeDropdownLabel(otherOffers, bestOffer.operator_id),
    onItemClicked: onOfferClicked,
    isMobile: isMobile,
    isActive: isActive
  }), !isHotelOnly && showTooltip && /*#__PURE__*/_react["default"].createElement(StyledButton, {
    "data-hint-included": true,
    functional: true,
    isMobile: isMobile
  }, /*#__PURE__*/_react["default"].createElement(StyledHintButtonWrapper, null, /*#__PURE__*/_react["default"].createElement(_HintButton["default"], {
    as: "span"
  })), _localization.i18n.t('hotel.offer.includedPrice')));
});
HotelOfferCell.displayName = 'HotelOfferCell';
HotelOfferCell.propTypes = {
  onOfferClicked: _propTypes["default"].func.isRequired,
  onItemHovered: _propTypes["default"].func,
  mealType: _propTypes["default"].string.isRequired,
  isActive: _propTypes["default"].bool,
  nightsCount: _propTypes["default"].number.isRequired,
  offers: _propTypes["default"].arrayOf(_hotel.HotelOfferPropTypes).isRequired,
  showNights: _propTypes["default"].bool,
  isLast: _propTypes["default"].bool,
  isMobile: _propTypes["default"].bool,
  onHeaderClicked: _propTypes["default"].func
};
HotelOfferCell.defaultProps = {
  onItemHovered: undefined,
  isActive: false,
  showNights: false,
  isLast: false,
  isMobile: false,
  onHeaderClicked: null
};
var StyledMealType = _styledComponents["default"].div.withConfig({
  displayName: "HotelOfferCell__StyledMealType",
  componentId: "sc-8qtl5h-0"
})(["visibility:hidden;margin-top:3px;margin-bottom:7px;font-size:12px;text-align:center;word-break:break-word;line-height:1;font-weight:bold;color:", ";"], function (props) {
  return props.theme.colors.blackBase;
});
var StyledMealIcon = (0, _styledComponents["default"])(_userflow.Meal).withConfig({
  displayName: "HotelOfferCell__StyledMealIcon",
  componentId: "sc-8qtl5h-1"
})(["width:12px;height:12px;position:relative;top:1px;margin-right:5px;"]);
var StyledNoOffers = _styledComponents["default"].div.withConfig({
  displayName: "HotelOfferCell__StyledNoOffers",
  componentId: "sc-8qtl5h-2"
})(["visibility:", ";height:50px;display:flex;justify-content:center;align-items:center;font-size:12px;color:#a49885;"], function (props) {
  return props.isVisible ? 'visible' : 'hidden';
});
var StyledBestOffer = (0, _styledComponents["default"])(_HotelOfferButton["default"]).withConfig({
  displayName: "HotelOfferCell__StyledBestOffer",
  componentId: "sc-8qtl5h-3"
})(["margin-bottom:6px;"]);
var StyledOffersDropdown = (0, _styledComponents["default"])(_HotelOffersDropdown["default"]).withConfig({
  displayName: "HotelOfferCell__StyledOffersDropdown",
  componentId: "sc-8qtl5h-4"
})(["font-size:12px;padding-bottom:15px;"]);
var StyledDropdownLabel = _styledComponents["default"].span.withConfig({
  displayName: "HotelOfferCell__StyledDropdownLabel",
  componentId: "sc-8qtl5h-5"
})(["white-space:pre-line;"]);
var StyledNight = _styledComponents["default"].div.withConfig({
  displayName: "HotelOfferCell__StyledNight",
  componentId: "sc-8qtl5h-6"
})(["text-align:center;font-size:18px;padding-top:5px;padding-bottom:10px;"]);
var StyledEndDate = _styledComponents["default"].div.withConfig({
  displayName: "HotelOfferCell__StyledEndDate",
  componentId: "sc-8qtl5h-7"
})(["color:", ";padding-bottom:10px;"], function (_ref3) {
  var isActive = _ref3.isActive;
  return isActive ? '#8F7344' : '#919499';
});
var StyledContainer = _styledComponents["default"].div.withConfig({
  displayName: "HotelOfferCell__StyledContainer",
  componentId: "sc-8qtl5h-8"
})(["display:flex;flex-direction:column;align-items:center;padding:5px;position:relative;", " background:", ";", ",", "{color:", ";}", "{visibility:", ";}"], function (_ref4) {
  var isLast = _ref4.isLast;
  return isLast && "\n    padding-bottom: 20px;\n  ";
}, function (props) {
  return props.isActive ? 'rgba(248, 231, 28, 0.2)' : 'none';
}, StyledNight, _HotelOfferInfo.StyledText, function (props) {
  return props.isActive ? props.theme.colors.blackBase : props.theme.colors.greyLight;
}, StyledMealType, function (props) {
  return props.isActive ? 'visible' : 'hidden';
});
var StyledButton = (0, _styledComponents["default"])(_Button["default"]).withConfig({
  displayName: "HotelOfferCell__StyledButton",
  componentId: "sc-8qtl5h-9"
})(["position:absolute;left:50%;bottom:5px;transform:translate(-50%);color:", ";white-space:nowrap;font-size:", ";&:hover{cursor:default;}"], function (props) {
  return props.theme.colors.greyLight;
}, function (_ref5) {
  var isMobile = _ref5.isMobile;
  return isMobile ? '11px' : '12px';
});
var StyledHintButtonWrapper = _styledComponents["default"].span.withConfig({
  displayName: "HotelOfferCell__StyledHintButtonWrapper",
  componentId: "sc-8qtl5h-10"
})(["margin-right:5px;"]);
var _default = exports["default"] = HotelOfferCell;